import { render, staticRenderFns } from "./line.vue?vue&type=template&id=3b622985"
import script from "./line.vue?vue&type=script&lang=js"
export * from "./line.vue?vue&type=script&lang=js"
import style0 from "./line.vue?vue&type=style&index=0&id=3b622985&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports